import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Droplets } from "lucide-react";

const Navbar = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <nav
      data-testid="main-nav"
      className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between h-20 sm:h-24">
          {/* Left spacer/nav */}
          <div className="hidden sm:flex items-center gap-1 text-sm font-medium text-slate-300 flex-1">
            <Link
              to="/villesse"
              data-testid="nav-link-villesse"
              className="px-3 py-2 rounded-full hover:text-cyan-400 hover:bg-white/5 transition-all"
            >
              Villesse
            </Link>
            <Link
              to="/tavagnacco"
              data-testid="nav-link-tavagnacco"
              className="px-3 py-2 rounded-full hover:text-cyan-400 hover:bg-white/5 transition-all"
            >
              Tavagnacco
            </Link>
            <Link
              to="/work-in-progress"
              data-testid="nav-link-wip"
              className="px-3 py-2 rounded-full hover:text-amber-400 hover:bg-white/5 transition-all"
            >
              Prossima sede
            </Link>
          </div>

          {/* Centered logo */}
          <Link
            to="/"
            data-testid="nav-logo"
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center gap-3 sm:gap-4 group"
          >
            <div className="relative">
              <Droplets
                className="w-10 h-10 sm:w-12 sm:h-12 text-cyan-400 group-hover:text-cyan-300 transition-colors drop-shadow-[0_0_20px_rgba(0,229,255,0.7)]"
                strokeWidth={2.4}
              />
              <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-cyan-400 animate-pulse shadow-[0_0_12px_rgba(0,229,255,1)]" />
            </div>
            <span className="font-display font-black text-3xl sm:text-4xl md:text-5xl tracking-tight text-white leading-none drop-shadow-[0_0_24px_rgba(0,229,255,0.5)]">
              DMB<span className="text-cyan-400"> </span>S.r.l.
            </span>
          </Link>

          {/* Right side back button */}
          <div className="flex items-center justify-end flex-1">
            {!isHome && (
              <Link
                to="/"
                data-testid="nav-back-home"
                className="text-xs sm:text-sm font-semibold px-4 py-2 rounded-full bg-cyan-400/10 border border-cyan-400/30 text-cyan-300 hover:bg-cyan-400 hover:text-slate-950 transition-all"
              >
                ← Tutte le sedi
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
